import React from "react";

import UserAuditLogs from "../../../../components/User/UserAuditLogs";
import UserPageLayout from "../../../../components/User/UserPageLayout";

const ViewLogs = () => (
  <UserPageLayout title="Audit Logs">
        <UserAuditLogs />
  </UserPageLayout>
);

export default ViewLogs;
